module.exports = __webpack_public_path__ + "media/images/apple-podcast-75c9e6ae45a6e34b4766ab721ce5fb0f.jpg";